import { render, staticRenderFns } from "./PageRevisions.vue?vue&type=template&id=68186d7f&"
import script from "./PageRevisions.vue?vue&type=script&lang=js&"
export * from "./PageRevisions.vue?vue&type=script&lang=js&"
import style0 from "./PageRevisions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports